import {
  ILeisureWebApiProduct,
  ILeisureWebApiProductPartner,
  ILeisureWebApiVariant,
  ILeisureWebApiVerifyToken,
} from '~/api/services/leisure-web-api/index.type'
import { IDomesticOrderDiscountCouponSelectModal } from '~/api/converters/domestic/order/Discount/CouponSelectModal/index.type'
import {
  ExpressBusRouterBusGrade,
  IExpressBusRouterCancelPreviewResponse,
  IExpressBusRouterDetailResponse,
} from '~/api/services/express-bus-router/index.type'
import { TDomesticPropertyResponseType } from '~/api/services/domestic-property/index.type'
import {
  IGetPropertyConfigResponse,
  IProductConfigCancelPolicy,
  TGetRoomTypeConfigResponse,
} from '~/api/services/product-config/index.type'
import {
  DomesticPropertyRatePlan,
  DomesticPropertyRoomType,
} from '~/api/routes/domestic/order/controller/utils'
import { TDomesticCouponResponseData } from '~/api/services/coupon/index.type'
import { IDomesticOrderDiscount } from '~/api/converters/domestic/order/Discount/index.type'
import { TGetBusPriceAndSeatsReturn } from '~/api/utils/bus'
import {
  TTransportationTrainPackageFaresResponseData,
  TTransportationTrainResponseData,
  TTransportationTrainSeatMapResponseData,
} from '~/api/services/transportation/index.type'
import { ICouponInstances } from '~/api/services/coupon-platform/index.type'
import {
  IYaPaymentApiPaymentNoticeCheck,
  IYaPaymentApiPaymentPolicy,
} from '~/api/services/ya-payment-api/index.type'
import { IMemberApi03Member } from '~/api/services/member-api-03/index.type'
import { TCommonUserViewer, TCommonVisitorViewer } from '~/api/converters/common/viewer/index.type'
import { TCommonViewer } from '~/api/routes/common/type'
import { IDomesticOrderClientLogs } from '~/api/converters/domestic/order/ClientLogs/index.type'
import { IDomesticOrderBenefitSection } from '~/api/converters/domestic/order/BenefitSection/index.type'
import { IAuthorizationMessageApiSendCertification } from '~/api/services/authorization-message-api/index.type'
import { IMemberApi, MemberCertifiaction } from '~/api/services/member-api/index.type'
import { ICommonOrderPaymentMethod } from '~/api/converters/common/PaymentMethod/index.type'
import { IEfinNolPointAmountWithSuccess } from '~/api/services/efin-api/index.type'
import { IReviewApiServiceExpectedReward } from '~/api/services/review-api/index.type'
import { IDomesticOrderPaymentWithDiscountPoint } from '~/api/converters/domestic/order/PaymentWithDiscountPoint/index.type'
import { IDomesticOrderTotalPayment } from '~/api/converters/domestic/order/TotalPayment/index.type'
import {
  IDomesticOrderSheetLeisureToken,
  IDomesticOrderSubmitForm,
} from '~/api/converters/domestic/order/SubmitForm/index.type'
import { IDomesticOrderAgreePolicy } from '~/api/converters/domestic/order/AgreePolicy/index.type'
import { IDomesticOrderProductSection } from '~/api/converters/domestic/order/ProductSection/index.type'
import { ICommonOrderPoint } from '~/api/converters/common/Point/index.type'
import { TInventoryRatePlanItemDate } from '~/api/services/rate-plan-api/index.type'
import { ICancelPolicy } from '~/api/converters/domestic/order/ProductSection/Property/index.type'
import { IDomesticOrderCustomer } from '~/api/converters/domestic/order/Customer/index.type'
import { IDomesticOrderUser } from '~/api/converters/domestic/order/User/index.type'
import { IPointConnectCJOnePointResponse } from '~/api/services/point-connect/index.type'
import { IDomesticOrderTimer } from '~/api/converters/domestic/order/Timer/index.type'
import { IValidateAdditionalOrderResponse } from '~/api/converters/domestic/order/Validate/validateLeisureAdditionalOrder'
import { ICommonNolMoneyAgreements } from '~/api/converters/common/NolMoney/agreements.type'
import { INolMoneyInfo, INolMoneyPgPayment } from '~/api/routes/common/nol-money/type'
import {
  INolMoneyAMLStatus,
  INolMoneyLastCashReceiptInfo,
  INolMoneyFinancialInstitutionMaintenances,
} from '~/api/services/nol-money-webapi/index.type'
import { INolMemberTermsAgreements } from '~/api/services/nol-member-api/index.type'
import { ICommonNolMoneyLastCashReceiptInfo } from '~/api/converters/common/NolMoney/lastCashReceipt.type'
import { CategoryRewardData } from '~/api/services/payment-reward-api/index.type'
import { ICommonPaymentRewards } from '~/api/converters/common/PaymentReward/index.type'

export enum ItemType {
  Property = 'property',
  Leisure = 'leisure',
  Train = 'train',
  Bus = 'bus',
}

export type PropertyQS = {
  type: ItemType.Property
  propertyId: number
  checkInDate: string
  checkOutDate: string
  checkInAt: string
  checkOutAt: string

  // roomTypeId & useType 혹은 ratePlanId & ratePlanVersion 존재해야함
  roomTypeId?: number // 신규생성 숙소의 경우 없을 수 있음.
  useType: 'R' | 'S' | 'D'
  ratePlanId?: number
  ratePlanVersion?: number

  surchargeIds?: number[]
  adults: number
  childrenAges?: number[]
}

export type LeisureQS = {
  type: ItemType.Leisure
  id: number
  productVersion?: number
  options: {
    id: number
    quantity: number
    date?: string
    time?: string
  }[]
}

export type TrainItemQS = {
  trainNo: string
  goodsNo: string
  departureStationCode: string
  runningDate: string
  arrivalStationCode: string
  carriageClassCode: string
  seats: string[]
}

export type TrainQS = {
  type: ItemType.Train
  adults: number
  child: number
  single: TrainItemQS
  returns?: TrainItemQS
}

export type MetaQS = {
  trackCode?: string | null
  trackcode?: string | null
  cartId?: string
  cartOptionIds?: string[]
  isCartSelectAll?: string
  srpKeyword?: string
  cgntId?: string // query string 아님
  orderGroupId?: string // 추가 구매건 대응을 위한 원 주문 번호.
}

export type BusQS = {
  type: ItemType.Bus
  going: BusItemQS
  returns: BusItemQS
}

export type BusItemQS = {
  allocationArrivalTerminalNo: string
  allocationDepartureTerminalNo: string
  allocationDepartureTime: string
  arrivalTerminalNo: string
  busGrade: BusGradeQS
  departureDate: string
  departureTerminalNo: string
  departureTime: string
  transportationCompanyCode: string
  seats: BusItemSeatQS[]
  totalSeats: number
}

export type BusItemSeatQS = {
  seatNo: number
  ticketType: string
}

export type BusGradeQS = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'

export type ProductQS = PropertyQS | LeisureQS | TrainQS | BusQS
export type ItemQS = ProductQS | MetaQS

export type PageParams = Record<number, ItemQS>

export type PropertyMashup = ({
  t: ItemType.Property
  type: ItemType.Property
  typeIdx: number
  childrenAges: string
  surchargeIds: string
  config: IGetPropertyConfigResponse
  roomType: DomesticPropertyRoomType & {
    config: TGetRoomTypeConfigResponse
  }
  ratePlan: DomesticPropertyRatePlan
  available: boolean
  price: number | null
  coupons: TDomesticCouponResponseData
  additionalOneCoupons: TDomesticCouponResponseData
  additionalTwoCoupons: TDomesticCouponResponseData
  cancelPolicies: IProductConfigCancelPolicy | null
  confirmedReservation: boolean
  memberClassCode: string
  partnersCompanyName: string | null
} & Omit<PropertyQS, 'childrenAges' | 'surchargeIds'> &
  TDomesticPropertyResponseType['data'] & { published: boolean })[]

export type LeisureMashup = (ILeisureWebApiProduct & {
  leisureProductVariants: (ILeisureWebApiVariant &
    LeisureQS['options'][number] & { price: number | null; totalPrice: number | null })[]
  price: number | null
  t: ItemType.Leisure
  type: ItemType.Leisure
  typeIdx: number
  available: boolean
  coupons: ICouponInstances[]
  partners: ILeisureWebApiProductPartner[]
} & LeisureQS)[]

export type TrainMashupItem = {
  seats: Array<
    {
      carriageNo: string
      seatNo: string
    } & TTransportationTrainSeatMapResponseData[number]
  >
  packageFares: TTransportationTrainPackageFaresResponseData
  price: number | null
  packageDiscountAmount: number | null
  adultPrice: number | null
  childPrice: number | null
  isPromotionApplicable: boolean
} & Omit<TrainItemQS, 'seats'> &
  TTransportationTrainResponseData

export type TrainMashup = ({
  t: ItemType.Train
  type: ItemType.Train
  typeIdx: number
  adults: number
  child: number
  single: TrainMashupItem
  returns: TrainMashupItem | null
  available: boolean
  price: number | null
  availablePackageDiscountAmount: number
  adultPrice: number
  childPrice: number
  coupons: ICouponInstances[]
} & Omit<TrainQS, 'single' | 'returns'>)[]

// DomesticOrderBody['bus'][number]['going'] 를 참조하면 schema generate 에러 발생하기 때문에
// params 에만 존재하는 타입은 별도로 정의
export type TBusParamsExclusive = {
  allocationArrivalTerminalNo: string
  allocationDepartureTerminalNo: string
  allocationDepartureTime: string
  busGrade: ExpressBusRouterBusGrade
  totalSeats: number
  transportationCompanyCode: string
  seats: {
    seatNo: number
    ticketType: '1' | '2' | '8' | '9'
  }[]
}

export type BusWayMashup = IExpressBusRouterDetailResponse['reservations'][number] & {
  cancelPreviews: IExpressBusRouterCancelPreviewResponse['buses'][number]['cancelPreviews'] | null
} & Omit<TBusParamsExclusive, 'seats'> &
  TGetBusPriceAndSeatsReturn & { transportationCompanyName: string }

export type BusMashup = {
  going: BusWayMashup
  returns: BusWayMashup | null
  t: ItemType.Bus
  type: ItemType.Bus
  typeIdx: number
  price: number
  available: boolean
  coupons: ICouponInstances[]
}[]

type TTrainParamsItem = {
  seats: {
    carriageNo: string
    seatNo: string
  }[]
  trainNo: string
  goodsNo: string
  departureStationCode: string
  runningDate: string
  arrivalStationCode: string
  carriageClassCode: string
}

type TBusParamsItem = {
  seats: {
    seatNo: number
    ticketType: '1' | '2' | '8' | '9'
  }[]
  allocationArrivalTerminalNo: string
  allocationDepartureTerminalNo: string
  allocationDepartureTime: string
  arrivalTerminalNo: string
  busGrade: ExpressBusRouterBusGrade
  departureDate: string
  departureTerminalNo: string
  transportationCompanyCode: string
  totalSeats: number
  departureTime: string
}

export interface IDomesticOrderConverterCommonParams {
  totalPrice: number
  propertyMashup: PropertyMashup
  leisureMashup: LeisureMashup
  trainMashup: TrainMashup
  busMashup: BusMashup
  meta: MetaQS
  paramsByType: {
    properties: {
      propertyId: number
      childrenAges: number[]
      surchargeIds: number[]
      type: ItemType.Property
      checkInDate: string
      checkOutDate: string
      checkInAt: string
      checkOutAt: string
      useType: 'R' | 'S' | 'D'
      adults: number
      ratePlanId?: number | undefined
      ratePlanVersion?: number | undefined
      roomTypeId?: number | undefined
    }[]
    leisures: {
      type: ItemType.Leisure
      options: {
        id: number
        quantity: number
        date?: string | undefined
        time?: string | undefined
      }[]
      id: number
      productVersion?: number | undefined
    }[]
    trains: {
      type: ItemType.Train
      adults: number
      child: number
      single: TTrainParamsItem
      returns?: TTrainParamsItem
    }[]
    buses: {
      type: ItemType.Bus
      going: TBusParamsItem
      returns?: TBusParamsItem
    }[]
  }
  paymentPolicy: IYaPaymentApiPaymentPolicy
  paymentNotice: IYaPaymentApiPaymentNoticeCheck
  vigToken: string
  reviewExpectedReward: IReviewApiServiceExpectedReward
  leisureTokenData?: ILeisureWebApiVerifyToken[]
  additionalOrderData?: IValidateAdditionalOrderResponse
  nolMoneyInfo: INolMoneyInfo | null
  isApp: boolean
  nolMoneyRewards: CategoryRewardData[]
}

export type TMaxDiscountLimit = {
  timeout: number
  maxLength: number
}

export interface IDomesticOrderConverterMemberParams extends IDomesticOrderConverterCommonParams {
  req: any
  memberNo: string
  isMember: true
  isLinkedNol: boolean
  isNolCardFirstPayPromotion: boolean
  viewer: TCommonUserViewer
  member: IMemberApi
  nolPoint: IEfinNolPointAmountWithSuccess
  cjPoint: IPointConnectCJOnePointResponse
  simpleMember: IMemberApi03Member
  maxDiscountLimit: TMaxDiscountLimit
  leisureTokens?: IDomesticOrderSheetLeisureToken[]
  certification?: MemberCertifiaction
  nolMemberAgreements: INolMemberTermsAgreements
  lastCashReceiptInfo: INolMoneyLastCashReceiptInfo | null
}

export interface IDomesticOrderConverterVisitorParams extends IDomesticOrderConverterCommonParams {
  isMember: false
  viewer: TCommonVisitorViewer
}

export type TDomesticOrderViewer =
  | IDomesticOrderConverterMemberParams['viewer']
  | IDomesticOrderConverterVisitorParams['viewer']

/**
 * 주문서 converter params
 */
export type DomesticOrderConverterParams =
  | IDomesticOrderConverterMemberParams
  | IDomesticOrderConverterVisitorParams

/**
 * 주문서 converter response
 */
export interface IDomesticOrderConverterCommonResponse {
  meta: MetaQS
  unAvailableItemCategory?: ItemType
  params: DomesticOrderConverterParams['paramsByType']
  paymentMethod: ICommonOrderPaymentMethod
  clientLogs: IDomesticOrderClientLogs
  benefitSection: IDomesticOrderBenefitSection
  productSection: IDomesticOrderProductSection
  paymentWithDiscountPoint: IDomesticOrderPaymentWithDiscountPoint
  totalPayment: IDomesticOrderTotalPayment
  agreePolicy: IDomesticOrderAgreePolicy
  submitForm: IDomesticOrderSubmitForm
  customer: IDomesticOrderCustomer
  user: IDomesticOrderUser
  timer?: IDomesticOrderTimer
  paymentRewards: ICommonPaymentRewards
  /** 추가 구매 전용 상품이지만 추가 구매 불가능한 경우 (원 주문 id 가 없는 케이스) */
  unAvailableAdditionalOrder?: boolean
}

export interface IDomesticAdditionalOrder {
  isAdditionalOrder: true
}
export interface IDomesticOriginalOrder {
  isAdditionalOrder: false
  couponSelectModal: IDomesticOrderDiscountCouponSelectModal
  discount: IDomesticOrderDiscount
  point: ICommonOrderPoint
}

export type IDomesticOrderConverterMemberResponse = IDomesticOrderConverterCommonResponse &
  (IDomesticAdditionalOrder | IDomesticOriginalOrder) & {
    isMember: true
    isYouth: boolean
    viewer: IDomesticOrderConverterMemberParams['viewer']
    nolMoneyAgreements: ICommonNolMoneyAgreements
    lastCashReceiptInfo: ICommonNolMoneyLastCashReceiptInfo
  }

export type IDomesticOrderConverterVisitorResponse = IDomesticOrderConverterCommonResponse & {
  isMember: false
  viewer: IDomesticOrderConverterVisitorParams['viewer']
}

export type DomesticOrderConverterResponse =
  | IDomesticOrderConverterMemberResponse
  | IDomesticOrderConverterVisitorResponse

export type ValidateDomesticOrderBody = {
  viewer: Pick<TCommonViewer, 'role' | 'hashedMemberNo'>
  isUsePoint: boolean
  queryString: string
  pgPayment: INolMoneyPgPayment
  authInfo: {
    phone: string
    name: string
  }
  accessToken: string
}

export type ValidateDomesticOrderResponse = {
  success: true
}

export type ValidateDomesticOrderCommon = {
  isMember: boolean
  appVersion: string | undefined
  viewer: Pick<TCommonViewer, 'role' | 'hashedMemberNo'>
  freshViewer: TCommonViewer
  paymentPolicy: IYaPaymentApiPaymentPolicy
  pgPayment: INolMoneyPgPayment
  propertyMashup: PropertyMashup
  leisureMashup: LeisureMashup
  trainMashup: TrainMashup
  busMashup: BusMashup
  authInfo: {
    phone: string
    name: string
  }
  /** 놀머니 선택한 회원: INolMoneyAMLStatus / 그 외: null */
  amlStatus: INolMoneyAMLStatus | null
  /** 놀머니 선택한 회원: INolMoneyFinancialInstitutionMaintenances / 그 외: null */
  maintenancesList: INolMoneyFinancialInstitutionMaintenances | null
}

export type ValidateDomesticOrderUser = ValidateDomesticOrderCommon & {
  isUsePoint: boolean
  simpleMember: IMemberApi03Member
}

export type ValidateDomesticOrderVisitor = ValidateDomesticOrderCommon & {
  sessionPhone: string
}

export const DomesticOrderAlertAction = {
  NONE: 'NONE',
  DISMISS: 'DISMISS',
  LOGIN: 'LOGIN',
  COUPON: 'COUPON',
  REFRESH: 'REFRESH',
  HOME: 'HOME',
}

export type TDomesticOrderAlertAction =
  (typeof DomesticOrderAlertAction)[keyof typeof DomesticOrderAlertAction]

export interface IPrepaymentAgreedResponse {
  /**
   * 포인트 약관 동의 여부
   */
  isPrepaymentAgreed: boolean
  /**
   * 포인트 약관 동의 날짜 : 현재 날짜
   */
  prepaymentAgreedDate: string
}

export type DomesticOrderCancelPolicyPropertyBody = {
  cancelPolicy?: number
  propertyId: number
  checkInDate: string
  checkOutDate: string
  ratePlanDates: TInventoryRatePlanItemDate[]
  price: number
}

export type DomesticOrderCancelPolicyPropertyResponse = ICancelPolicy | null

export type DomesticOrderCancelPolicyBusBody = {
  departureDate: string
  departureTime: string
  departureTerminalNo: string
  arrivalTerminalNo: string
  tripDuration: string
  allocationDepartureTime: string
  allocationDepartureTerminalNo: string
  allocationArrivalTerminalNo: string
  busGrade: string
  transportationCompanyCode: string
}

export type DomesticOrderCancelPolicyBusResponse = ICancelPolicy | null
export type DomesticOrderSendSMSBody = {
  phoneNum: string
}

export type DomesticOrderSendSMSResponse = IAuthorizationMessageApiSendCertification

export type DomesticOrderValidateSMSBody = {
  name: string
  phoneNum: string
  code: string
}

export type DomesticOrderValidateSMSResponse = {
  success: boolean
}

export const isMemberParams = (
  params: DomesticOrderConverterParams
): params is IDomesticOrderConverterMemberParams => {
  return params.isMember
}

export const PassengerTypeCode = {
  ADULT: '1',
  CHILD: '3',
} as const
